// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vphf","textarea":"styles_textarea__2E9so"};